import { Directive } from '@angular/core';

import { EqualSizeService } from './equal-size.service';

@Directive({ standalone: false, selector: '[adsptEqualSizeContainer]', providers: [EqualSizeService] })
export class EqualSizeContainerDirective {}
